package org.catharsis.spendtel.feature.presentation.auth

import androidx.compose.runtime.Composable
import androidx.navigation.NavHostController
import org.catharsis.spendtel.feature.presentation.web.WebAuthenticationScreen

@Composable
actual fun AuthenticationScreen(navHostController: NavHostController) {
    WebAuthenticationScreen(navHostController)
}
